import { ReactEventHandler } from "react";
import styled, { css, keyframes } from "styled-components";
import { Button, Icon } from "@blueprintjs/core";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const IconWrapper = styled.span<{ isRotating?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ isRotating }) =>
    isRotating &&
    css`
      animation: ${rotate} 1s linear infinite;
    `}
`;

export default function RefreshButton({
  isLoading,
  handleSubmit,
  title,
  className,
}: {
  isLoading: boolean;
  handleSubmit: (e?: ReactEventHandler) => void;
  title?: string;
  className?: string;
}) {
  return (
    <Button
      intent={isLoading ? "primary" : "none"}
      className={className}
      onClick={(e) => handleSubmit()}
      icon={
        <IconWrapper isRotating={isLoading}>
          <Icon icon="refresh" />
        </IconWrapper>
      }
    >
      {title}
    </Button>
  );
}
